import api from "./axios";
import { fetchAndDownload } from "../utils/exportCsv";

export const listTaskGroups = (params = {}) => api.get("/task-groups", { params });
export const getTaskGroup = (id) => api.get(`/task-groups/${id}`);
export const createTaskGroup = (payload) => api.post("/task-groups", payload);
export const updateTaskGroup = (id, payload) => api.put(`/task-groups/${id}`, payload);
export const deleteTaskGroup = (id) => api.delete(`/task-groups/${id}`);

// Dev-gated: round-trip export + bulk import.
export const exportTaskGroups = () =>
  fetchAndDownload("/task-groups/export", {}, "task-groups");
export const bulkImportTaskGroups = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/task-groups/bulk-import", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
